module.exports = __webpack_public_path__ + "img/pic_ub_new.e27a9cd2.png";